module.exports = __webpack_public_path__ + "static/media/hiper.5d408770.svg";